import { z } from 'zod';

const numericStringSchema = z
  .string()
  .regex(/^\d+(\.\d{1,2})?$/, 'COMMON:VALIDATIONS:ONLY_NUMBERS')
  .min(1, 'COMMON:VALIDATIONS:ONLY_NUMBERS')
  .max(16, 'LIMTIS:ERRORS:MAX_NUMBER');

const limitFormSchema = z.object({
  description: z
    .string()
    .min(1, 'COMMON:VALIDATIONS:REQUIRED_FIELD')
    .max(255, 'USERS_MANAGEMENT:ERROR:EMAIL_MAX_LENGTH'),
  doubleFactor: z.boolean(),
  transactionLimitReceived: numericStringSchema,
  dailyLimitReceived: numericStringSchema,
  monthlyLimitReceived: numericStringSchema,
  dailyLimitTxReceived: numericStringSchema,
  monthlyLimitTxReceived: numericStringSchema,
  dailyLimitSent: numericStringSchema,
  monthlyLimitSent: numericStringSchema,
  dailyLimitTxSent: numericStringSchema,
  monthlyLimitTxSent: numericStringSchema,
  transactionLimitSent: numericStringSchema,
});

export type limitFormSchemaType = z.infer<typeof limitFormSchema>;

export default limitFormSchema;
